/*
 *  -----------------------------------------------------------------------
 *    <copyright file="actions-donut-chart.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { HC_COLORS_MUTED, OpraColours } from '../../../../interfaces/opra-chart.interface';
import { useTranslation } from 'hooks';
import DonutChart, { IOpraDonutSeries } from 'views/components/core/charts/donut-chart';
import Loading from 'views/components/core/loading';
import PanelFrame from 'views/components/core/panel-frame';

interface ObservationsDonutProps {
    observations: any[];
    datasetDate: string;
}

const ObservationsDonutChart = ({ observations, datasetDate }: ObservationsDonutProps) => {
    const { t } = useTranslation();
    const [chartData, setChartData] = useState<IOpraDonutSeries[]>(null);

    useEffect(() => {
        const colors = [
            HC_COLORS_MUTED[OpraColours.Red],
            HC_COLORS_MUTED[OpraColours.Amber],
            HC_COLORS_MUTED[OpraColours.Green],
        ];
        const array = [...observations]
            .filter((item: any) => !item.closedDate && moment(datasetDate) >= moment(item.observationDate))
            .map((item: any) => {
                let color = '';
                const today = moment();
                const observationDate = moment(item.observationDate);
                const diff = today.diff(observationDate, 'days');
                if (diff <= 14) color = colors[2];
                if (diff > 14 && diff <= 28) color = colors[1];
                if (diff > 28) color = colors[0];
                return {
                    ...item,
                    color,
                };
            });
        setChartData(
            colors.map(
                (series, idx): IOpraDonutSeries => ({
                    name: [
                        t('cm:observationsAgingLegendRed'),
                        t('cm:observationsAgingLegendYellow'),
                        t('cm:observationsAgingLegendGreen'),
                    ][idx],
                    colour: idx + 1,
                    segmentSize: array.filter((a) => series === a.color).length,
                }),
            ),
        );
    }, [observations]);

    if (!chartData) return <Loading inside />;

    return (
        <PanelFrame title={t('cm:observationsAging')}>
            {(getRef: any) => (
                <DonutChart
                    getRef={getRef}
                    title={t('cm:observationsAging')}
                    hidePlotTitle
                    data={chartData}
                    entityType={t('cm:observations')}
                    onClick={() => {}}
                    noDataMessage={t('cm:observationsAgingNoDataMessage')}
                />
            )}
        </PanelFrame>
    );
};

export default ObservationsDonutChart;
